import { LanguageType } from '@/custom-types';
import { useUserLanguage } from '@/customHooks';
import { PaymentStatusOption } from '@/graphql/generated';

type PaymentStatusOptionPillProps = {
  option: PaymentStatusOption;
};

const optionMapping = (option: PaymentStatusOption, language: LanguageType) => {
  const pendingStyle = "text-[#FF971D] bg-[#FF971D21]"; // equivalent to notReceivedStyle
  const rejectedStyle = "text-[#ff7878] bg-[#ffd7d7]"; // equivalent to overdueStyle
  const confirmedStyle = "text-[#4a9462] bg-[#d2f3dc]"; // equivalent to receivedStyle
  const otherStyle = "text-[#808080] bg-[#ECECEC]";

  const mapping = {
    en: {
      [PaymentStatusOption.Pending]: { text: 'Pending', className: pendingStyle },
      [PaymentStatusOption.Confirmed]: { text: 'Confirmed', className: confirmedStyle },
      [PaymentStatusOption.Rejected]: { text: 'Rejected', className: rejectedStyle },
      [PaymentStatusOption.Abandoned]: { text: 'Abandoned', className: otherStyle },
      [PaymentStatusOption.Aborted]: { text: 'Aborted', className: otherStyle },
      [PaymentStatusOption.Expired]: { text: 'Expired', className: otherStyle },
    },
    es: {
      [PaymentStatusOption.Pending]: { text: 'Pendiente', className: pendingStyle },
      [PaymentStatusOption.Confirmed]: { text: 'Confirmado', className: confirmedStyle },
      [PaymentStatusOption.Rejected]: { text: 'Rechazado', className: rejectedStyle },
      [PaymentStatusOption.Abandoned]: { text: 'Abandonado', className: otherStyle },
      [PaymentStatusOption.Aborted]: { text: 'Abortado', className: otherStyle },
      [PaymentStatusOption.Expired]: { text: 'Expirado', className: otherStyle },
    },
  };

  return mapping[language][option] ?? { text: option, className: otherStyle };
};

export const PaymentStatusOptionPill = ({ option }: PaymentStatusOptionPillProps) => {
  const userLanguage = useUserLanguage();
  const { text, className } = optionMapping(option, userLanguage);

  return (
    <div className={`inline-flex items-center justify-center px-3 py-1 rounded-[20px] text-[0.7rem] font-bold ${className}`}>
      {text}
    </div>
  );
};
